import classNames from 'classnames'
import React from 'react'
import Image from 'components/Image'
import './index.css'
import useDispatch from 'hooks/use-dispatch'
import updateSelectedQuickShadeVariantIdAction from 'modules/variant/redux/actions/update-selected-quick-shade-variant-id'
import Button from 'components/Button'
import retryImageLoadUtil from 'containers/QuickShopProductSidebar/components/ColorSwatches/util/retry-image-load'
import logUtil from 'utils/log'
import getDefaultSwatchImageProductUtil from 'modules/product/utils/get-default-swatch-image'
import logEventAnalyticsUtil from 'utils/analytics/log-event'

const ANALYTICS_EVENTS = {
  SELECT_QUICK_SHADE: 'SELECT_QUICK_SHADE'
}

/**
 * @param {boolean} isSelected
 * @param {number} featuredVariantId
 * @param {ProductVariantCollection} variant
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductCardQuickShadesItem ({
  featuredVariantId,
  isSelected,
  variant
}) {
  const dispatch = useDispatch()
  const variantId = variant?.variant_id
  const iconUrl = variant.option_icon_url
  const [shouldUseDefaultIconUrl, setShouldUseDefaultIconUrl] = React.useState(!iconUrl)
  const defaultIconUrl = getDefaultSwatchImageProductUtil(variant?.variant_image_url)
  const imageUrl = shouldUseDefaultIconUrl
    ? defaultIconUrl
    : iconUrl

  const handleImageError = async (error) => {
    const success = await retryImageLoadUtil(imageUrl)

    if (success) {
      logUtil('QuickShopProductSidebarColorSwatchesItem#handleImageError').debug('Image loaded successfully')
      return
    }

    setShouldUseDefaultIconUrl(true)
    logUtil('QuickShopProductSidebarColorSwatchesItem#handleImageError').error('Image load failed after retries', {
      error,
      failedUrl: imageUrl
    })
  }

  const handleClick = (event) => {
    event.preventDefault()
    event.stopPropagation()

    if (isSelected) {
      return
    }

    dispatch(
      updateSelectedQuickShadeVariantIdAction({
        featuredVariantId,
        value: variantId
      })
    )

    logEventAnalyticsUtil(ANALYTICS_EVENTS.SELECT_QUICK_SHADE)
  }

  return (
    <Button
      className={
        classNames({
          'quick-shades-item': true,
          'quick-shades-item_selected': isSelected,
          'quick-shades-item_unavailable': variant?.available === false
        })
      }
      onClick={handleClick}
    >
      <Image
        className='quick-shades-item-color'
        src={imageUrl}
        onError={handleImageError}
      />
    </Button>
  )
}
